import React from 'react';
import {
  Button,
  Input,
  Modal,
  ModalProps,
  Row,
  Space,
} from 'antd';
import { SiteContent } from 'components/common';
import { playSound } from 'utils';

type Props = ModalProps & {
  onInputList: Function;
};

const CodeListInputDialog = (props: Props) => {
  const { useState } = React;
  const [textContent, setTextContent] = useState('');

  const dialogFooter = () => {
    return (
      <Row justify="end">
        <Space>
          <Button
            onClick={onCancel}
            size="large"
          >
            Cancel
          </Button>
          <Button
            disabled={!textContent}
            onClick={onConfirm}
            size="large"
            style={{ minWidth: 82 }}
            type="primary"
          >
            OK
          </Button>
        </Space>
      </Row>
    );
  };

  const onCancel = (evt: any) => {
    if (props.onCancel) props.onCancel(evt);
  };

  const onChange = (evt: any) => {
    const t = evt.target.value;

    setTextContent(t.replace(/\t/g, '\n'));
  };

  const onConfirm = () => {
    const list = textContent.trim().split('\n')
      .map(e => e.trim())
      .filter(e => e !== '');

    if (list.length > 0) {
      playSound('bell');
      props.onInputList(list);
      onCancel(undefined);
    }
  };

  const onKeyDown = (evt: any) => {
    evt.stopPropagation();
    evt.nativeEvent.stopImmediatePropagation();
  };

  return (<>
    <Modal
      { ...props }
      footer={dialogFooter()}
    >
      <SiteContent className="common-content">
        <Input.TextArea
          allowClear
          autoFocus
          onChange={onChange}
          onKeyDown={onKeyDown}
          style={{ height: 'calc(100vh - 260px)', maxHeight: 400 }}
        />
      </SiteContent>
    </Modal>
  </>);
};

export default CodeListInputDialog;
